import { render, staticRenderFns } from "./add-dialog.vue?vue&type=template&id=35f7fdd5"
import script from "./add-dialog.vue?vue&type=script&lang=js"
export * from "./add-dialog.vue?vue&type=script&lang=js"
import style0 from "./add-dialog.vue?vue&type=style&index=0&id=35f7fdd5&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports